import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { businessInfo, socialLinks } from '../config/businessInfo';

const quickLinks = [
  { label: 'Home', to: '/' },
  { label: 'Menu', to: '/menu' },
  { label: 'Services', to: '/services' },
  { label: 'About', to: '/about' },
  { label: 'Contact', to: '/contact' },
];

const InstagramIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <circle cx="12" cy="12" r="4" />
    <circle cx="17.5" cy="6.5" r="1" />
  </svg>
);

const FacebookIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M15 8h2V4h-3a5 5 0 0 0-5 5v3H7v4h2v5h4v-5h3l1-4h-4V9a1 1 0 0 1 1-1h1Z" />
  </svg>
);

const TikTokIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
    <path d="M14 3v10.5a4.5 4.5 0 1 1-4.5-4.5" />
    <path d="M14 3a6 6 0 0 0 6 6" />
  </svg>
);

const socialIcons = {
  Instagram: <InstagramIcon />,
  Facebook: <FacebookIcon />,
  TikTok: <TikTokIcon />,
};

const Footer = () => {
  const { isAuthenticated, initializing } = useAuth();

  return (
    <footer className="site-footer">
      <div className="footer-content">
        <section className="footer-brand" aria-label="Vemmac Kitchen">
          <h2>{businessInfo.name}</h2>
          <p>Fresh meals, catering, and kitchen rentals from Asaba.</p>
          <div className="footer-social" aria-label="Social media">
            {socialLinks.map((item) => (
              <a
                key={item.label}
                href={item.href}
                className="social-link"
                aria-label={item.label}
                target="_blank"
                rel="noreferrer"
              >
                {socialIcons[item.label]}
              </a>
            ))}
          </div>
        </section>

        <nav className="footer-section footer-links-center" aria-label="Quick links">
          <h3>Quick Links</h3>
          {quickLinks.map((item) => (
            <Link key={item.label} to={item.to}>{item.label}</Link>
          ))}
        </nav>

        <section className="footer-section footer-contact">
          <h3>Contact</h3>
          <address>
            <strong>{businessInfo.name}</strong>
            {businessInfo.addressLines.map((line) => (
              <span key={line}>{line}</span>
            ))}
            <a href={businessInfo.phoneHref}>{businessInfo.phoneDisplay}</a>
            <a href={businessInfo.emailHref}>{businessInfo.email}</a>
          </address>
        </section>

        <nav className="footer-section footer-account" aria-label="Account">
          <h3>Account</h3>
          {!initializing && (
            isAuthenticated ? (
              <>
                <Link to="/profile">Profile</Link>
                <Link to="/profile?view=orders">Order History</Link>
              </>
            ) : (
              <Link to="/account">Login</Link>
            )
          )}
        </nav>
      </div>

      <div className="footer-copyright">
        <p>&copy; {new Date().getFullYear()} {businessInfo.name}. All rights reserved.</p>
      </div>
    </footer>
  );
};

export default Footer;
